import { Box } from "@mui/material";
import ListCreateTab from "components/ListCreateTab";
import React from "react";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import PhotoCameraBackIcon from "@mui/icons-material/PhotoCameraBack";
import AdImageCreate from "pages/advertisement/ad_images/AdImageCreate";
import AdImageList from "pages/advertisement/ad_images/AdImageList";

const AdImageManagement = () => {
  return (
    <Box sx={{ display: "flex", flex: 1 }}>
      <ListCreateTab
        mod="Ads Image"
        viewIcon={<PhotoCameraBackIcon />}
        createIcon={<AddPhotoAlternateIcon />}
        createChildren={<AdImageCreate />}
        listChildren={<AdImageList />}
      />
    </Box>
  );
};

export default AdImageManagement;
